import script from "./NewMeeting.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMeeting.vue?vue&type=script&setup=true&lang=js"

import "./NewMeeting.vue?vue&type=style&index=0&id=1a08961a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a08961a"]])

export default __exports__